import {useQuery} from 'react-query';
import {getLoanTypeDetail} from './getLoanTypeDetail';

const useGetLoanTypeDetail = (loanRequestGuid?: string) => {
  const {data, isLoading} = useQuery({
    queryKey: ['get-loan-type-detail', loanRequestGuid],
    queryFn: () => getLoanTypeDetail(loanRequestGuid),
    enabled: !!loanRequestGuid,
  });

  return {data, isLoading};
};
export default useGetLoanTypeDetail;
